"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var index_1 = require("../../index");
var shortlink_1 = __importDefault(require("../util/shortlink"));
var GoSwitch_1 = __importDefault(require("../../../../widgets/GoSwitch"));
var ConfigOption_1 = __importStar(require("../../../../widgets/ConfigOption"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        activeText: {
            color: '#6d9067',
        },
        inactiveText: {
            color: '#c85151',
        },
        regularText: {
            fontWeight: 400,
        },
        stateSwitch: {
            marginTop: 0,
            marginBottom: theme.spacing(4),
        },
    });
});
function LinkStateText() {
    var classes = useStyles();
    var drawerStates = (0, index_1.useDrawerState)();
    // Fetch short link state and dispatches from redux store through our helper hook.
    var _a = (0, shortlink_1.default)(drawerStates.relevantShortLink), shortLinkState = _a.shortLinkState, shortLinkDispatch = _a.shortLinkDispatch;
    var stateTitleActive = (react_1.default.createElement(react_1.default.Fragment, null,
        "Your link is ",
        react_1.default.createElement("span", { className: classes.activeText }, "active"),
        " and publicly accessible"));
    var stateTitleInactive = (react_1.default.createElement(react_1.default.Fragment, null,
        "Your link is ",
        react_1.default.createElement("span", { className: classes.inactiveText }, "inactive"),
        " and not publicly accessible"));
    return (react_1.default.createElement(ConfigOption_1.default, { title: [
            (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.state) === 'ACTIVE'
                ? stateTitleActive
                : stateTitleInactive,
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.regularText },
                "Share your link through",
                ' ',
                react_1.default.createElement("a", { href: "https://postman.gov.sg", target: "_blank", rel: "noreferrer" }, "Postman"),
                ", a mass messaging tool."),
        ], mobile: true, trailing: react_1.default.createElement(GoSwitch_1.default, { color: "primary", checked: (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.state) === 'ACTIVE', onChange: shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.toggleStatus, className: classes.stateSwitch }), trailingPosition: ConfigOption_1.TrailingPosition.center }));
}
exports.default = LinkStateText;
